import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import ThermalDocumentPreview from '@/components/ThermalDocumentPreview';
import PrintDocumentToolbar from '@/components/PrintDocumentToolbar';
import { documentTypeLabels } from '@/hooks/useOrderDocumentWorkflow';

export default function OrderDocumentPreviewDialog({
  previewOpen,
  setPreviewOpen,
  previewLoading,
  previewDocument,
  previewDocumentType,
  refreshDocumentPreview,
  saveAsPdf,
  browserPrint,
  pdfSaving,
  printLoading,
  thermalPreviewRef,
  closePreview,
}) {
  return (
    <Dialog
      open={previewOpen}
      onOpenChange={(open) => {
        setPreviewOpen(open);
        if (!open) closePreview();
      }}
    >
      <DialogContent className="max-h-[88vh] w-[95vw] max-w-2xl overflow-hidden border-border/70 bg-[#F4F1EA] p-0">
        <DialogHeader className="border-b border-black/10 bg-white/70 px-5 py-4">
          <DialogTitle>{documentTypeLabels[previewDocumentType] || 'Document'} Preview</DialogTitle>
        </DialogHeader>
        {previewLoading ? (
          <div className="px-5 py-12 text-center text-sm text-muted-foreground">Loading preview...</div>
        ) : previewDocument ? (
          <div className="space-y-4 px-5 py-4">
            <div className="sticky top-0 z-10 rounded-md bg-[#F4F1EA]/95 backdrop-blur-sm">
              <PrintDocumentToolbar
                onPreview={refreshDocumentPreview}
                onSavePdf={saveAsPdf}
                onBrowserPrint={browserPrint}
                previewLoading={previewLoading}
                pdfSaving={pdfSaving}
                printLoading={printLoading}
              />
            </div>
            <div className="max-h-[62vh] overflow-y-auto rounded-md border border-black/10 bg-[#ede9df] p-3">
              <div className="print-ticket-area">
                <ThermalDocumentPreview ref={thermalPreviewRef} document={previewDocument} />
              </div>
            </div>
          </div>
        ) : (
          <div className="px-5 py-12 text-center text-sm text-muted-foreground">No preview available.</div>
        )}
      </DialogContent>
    </Dialog>
  );
}
